// Pill-style switch used across the RD builder (replaces bare checkboxes for on/off settings).
export default function RddToggle({ checked, onChange, label, hint, size = "md", testId, disabled }) {
  return (
    <label className={`rdd-toggle ${checked ? "is-on" : ""} rdd-toggle-${size} ${disabled ? "is-disabled" : ""}`} data-testid={testId ? `${testId}-wrap` : undefined}>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        className="rdd-toggle-track"
        onClick={() => onChange(!checked)}
        data-testid={testId}
      >
        <span className="rdd-toggle-knob" />
      </button>
      {(label || hint) && (
        <span className="rdd-toggle-text">
          {label && <span className="rdd-toggle-label">{label}</span>}
          {hint && <span className="rdd-toggle-hint">{hint}</span>}
        </span>
      )}
    </label>
  );
}
